import { render } from "./Game.vue?vue&type=template&id=12e6ff67&scoped=true&bindings={\"notActive\":\"options\",\"playerIndex\":\"options\"}"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=12e6ff67&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12e6ff67"

export default script